<template>
  <div>
    <div v-if="!isCup">
      <div class="score">
        <div class="title">
          <div class="left">
            循环赛积分
          </div>
        </div>
        <div class="table">
          <div class="tr rh">
            <div class="th c1">球队</div>
            <div class="th c2">胜</div>
            <div class="th c3">平</div>
            <div class="th c4">负</div>
            <div class="th c5">净胜</div>
            <div class="th c6">积分</div>
          </div>
          <div class="tr rd" v-for="(item, index) in teamScores" :key="index" :class="index !== teamScores.length - 1 ? 'border' : ''">
            <div class="td c1 rd1">
              <div class="index">
                {{ index + 1 }}
              </div>
              <div class="img">
                <van-image :src="imgView(item.badge)" width="24px" height="24px"></van-image>
              </div>
              <div class="name">
                {{item.name}}
              </div>
            </div>
            <div class="td c2">{{ item.winRound }}</div>
            <div class="td c3">{{ item.tieRound }}</div>
            <div class="td c4">{{ item.loseRound }}</div>
            <div class="td c5">
              <span v-if="item.winRound - item.loseRound > 0">+</span>{{ item.winRound - item.loseRound }}</div>
            <div class="td c6">{{ item.totalScore }}</div>
          </div>
        </div>
      </div>
      <div class="rules">
        <div class="header">
          排名规则
        </div>
        <div class="detail">
          <div class="rule">1.积分高者优胜；</div>
          <div class="rule">2.积分相同时，净胜多者优先；</div>
          <div class="rule">3.以上均相同，球队排序高者优先；</div>
        </div>
      </div>
    </div>
    <div class="cup" v-else>
      <div class="turns" v-if="rounds && rounds.length > 0">
        <div class="item" :class="num === current + 1 ? 'choose' : 'nope'" v-for="(num, index) in rounds.length" :key="index" @click="changeRounds(index)">
          第{{ index + 1 }}轮
        </div>
      </div>
      <div class="games" :style="{'padding-top': current === 0 ? '24px' : '45px'}">
        <div class="game" :class="current === 0 ? 'w1' : 'w2'" v-for="(game, index) in rounds[current].games" :key="index">
          <div class="left" v-if="current > 0">
           <div class="prev-games">
             <div class="base top">
               <div class="logo">
                 <van-image :src="imgView(rounds[current - 1].games[(index + 1) * 2 - 2].homeTeam.badge)" width="20px" height="20px"></van-image>
               </div>
               <div class="logo" style="margin-top: 19px">
                 <van-image :src="imgView(rounds[current - 1].games[(index + 1) * 2 - 2].awayTeam.badge)" width="20px" height="20px"></van-image>
               </div>
             </div>
             <div class="base bottom">
               <div class="logo">
                 <van-image :src="imgView(rounds[current - 1].games[(index + 1) * 2 - 1].homeTeam.badge)" width="20px" height="20px"></van-image>
               </div>
               <div class="logo" style="margin-top: 19px">
                 <van-image :src="imgView(rounds[current - 1].games[(index + 1) * 2 - 1].awayTeam.badge)" width="20px" height="20px"></van-image>
               </div>
             </div>
           </div>
           <div class="line size-left">
             <div class="line1"></div>
             <div class="line2"></div>
             <div class="line3"></div>
             <div class="line4"></div>
           </div>
         </div>
          <div class="teams">
            <div class="time">{{getTime(game.beginDate)}}</div>
            <div class="team">
             <div style="display: flex; flex-flow: row;">
               <van-image :src="imgView(game.homeTeam.badge)"  width="20px" height="20px"></van-image>
               <div style="margin-left: 12px">{{game.homeTeam.name}}</div>
             </div>
              <div>{{game.homeScore >= 0 ? game.homeScore : '-'}}</div>
            </div>
            <div class="team">
             <div style="display: flex; flex-flow: row;">
               <van-image :src="imgView(game.awayTeam.badge)"  width="20px" height="20px"></van-image>
               <div style="margin-left: 12px">{{game.awayTeam.name}}</div>
             </div>
              <div>{{game.homeScore >= 0 ? game.homeScore : '-'}}</div>
            </div>
          </div>
          <div class="right" :style="{'top': current === 0 ? '-90px' : '-148px'}" v-if="current < rounds.length - 1 && (index + 1) % 2 === 0">
            <div class="line size-right" :class="current > 0 ? 'height' : ''">
              <div class="line1"></div>
              <div class="line2"></div>
              <div class="line3"></div>
              <div class="line4"></div>
            </div>
            <div class="next">
              <div class="logo">
                <van-image :src="imgView(rounds[current + 1].games[parseInt(index / 2 + '')].homeTeam.badge)" width="20px" height="20px"></van-image>
              </div>
              <div class="logo" style="margin-top: 19px">
                <van-image :src="imgView(rounds[current + 1].games[parseInt(index / 2 + '')].awayTeam.badge)" width="20px" height="20px"></van-image>
              </div>
            </div>
          </div>
          <div class="finish" v-if="current === rounds.length - 1">
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage } from 'vant'
Vue.use(VanImage)
import {getBMMatchGameList, getBMTeamScores} from "@/api/match"
import {DateUtil, QNImageUtil} from "@/utils"

export default {
  name: "Score",
  props: {
    matchId: {}
  },
  data() {
    return {
      isCup: false,
      teamScores: [],
      rules: '',
      rounds: [],
      current: 0,
      match: {}
    }
  },
  mounted() {
    this.getBMMatchGameList()
  },
  methods: {
    getBMMatchGameList() {
      const params = {
        matchId: this.matchId
      }
      getBMMatchGameList(params).then(res => {
        if (res) {
          const { data } = res
          const match = data.match
          if (match.ruleType === '淘汰赛') {
            this.isCup = true
            this.rounds = data.rounds

          } else {
            this.isCup = false
            this.getBMTeamScores()
          }
        }
      })
    },
    getBMTeamScores() {
      const params = {
        matchId: this.matchId
      }
      getBMTeamScores(params).then(res => {
        if (res) {
          const { data } = res
          this.teamScores = data.teamScores
          this.rules = data.rules
        }
      })
    },
    imgView(img) {
      return QNImageUtil.imageView(img)
    },
    getTime(date) {
      return date ? DateUtil.parseDateTime(date, '{y}/{m}/{d} {h}:{i}') : ''
    },
    changeRounds(index) {
      this.current = index
    },
  }
}
</script>

<style lang="scss">
.score {
  background-color: #ffffff;
  width: 100%;
  border-radius: 8px;
  box-sizing: border-box;
  padding-bottom: 16px;
  .title {
    font-weight: 500;
    box-sizing: border-box;
    padding: 0;
    height: 51px;
    margin: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: #E5E5E5 0.5px solid;
    .left {
      font-size: 14px;
      color: #191919;
    }
    .right {
      display: flex;
      justify-content: space-between;
      color: #8C8C8C;
      .img {
        margin-right: 4px;
      }
    }
  }
  .table {
    overflow: hidden;
    margin: 12px 16px 16px 16px;
    border-radius: 4px;
    .rh {
      height: 36px;
      background-color: #F0F3F9;
    }
    .rd {
      background-color: #F9FAFC;
    }
    .rd1 {
      height: 50px;
      background-color: #E8ECF3;
      box-sizing: border-box;
      padding: 0 8px 0 11px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .index {
        font-size: 12px;
        color: #474747;
      }
      .img {
        width: 24px;
      }
      .name {
        width: 60px;
        font-size: 12px;
        color: #474747;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow:ellipsis;
      }
    }
    .border {
      border-bottom: 0.5px #E5E5E5 solid;
    }
    .tr {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .th {
        font-size: 12px;
        color: #474747;
        text-align: center;
      }
      .td {
        text-align: center;
        font-size: 12px;
        color: #474747;
      }
      .c1 {
        width: 126px;
      }
      .c2 {
        width: 35px;
      }
      .c3 {
        width: 35px;
      }
      .c4 {
        width: 35px;
      }
      .c5 {
        width: 44px;
      }
      .c6 {
        width: 44px;
      }
    }
  }
}
.rules {
  background-color: #ffffff;
  width: 100%;
  border-radius: 8px;
  margin-top: 12px;
  box-sizing: border-box;
  padding: 20px 0 20px 16px;
  .header {
    font-size: 14px;
    color: #191919;
  }
  .detail {
    margin-top: 12px;
    .rule {
      line-height: 22px;
      font-size: 14px;
      color: #8C8C8C;
      font-weight: normal;
    }
  }
}
.cup {
  background-color: #ffffff;
  width: 100%;
  border-radius: 8px;
  box-sizing: border-box;
  padding-bottom: 16px;
  .turns {
    box-sizing: border-box;
    padding: 20px 16px 16px 16px;
    white-space: nowrap;
    overflow: auto;
    .choose {
      background-color: #191919;
      color: #FFFFFF;
    }
    .nope {
      color: #282828;
      background-color: #F3F3F3;
    }
    .item {
      display: inline-block;
      width: 80px;
      height: 28px;
      line-height: 28px;
      margin-right: 11px;
      border-radius: 14px;
      text-align: center;
    }
  }
  .size-left {
    width: 25px;
    height: 100px;
  }
  .size-right {
    width: 25px;
    height: 134px;
  }
  .height {
    height: 193px;
  }
  .line {
    position: relative;
    .line1 {
      position: absolute;
      top: 0;
      left: 0;
      height: 2px;
      width: 13px;
      background-color: #191919;
    }
    .line2 {
      position: absolute;
      top: 100%;
      left: 0;
      height: 2px;
      width: 13px;
      background-color: #191919;
    }
    .line3 {
      position: absolute;
      top: 0;
      left: 50%;
      height: 100%;
      width: 2px;
      background-color: #191919;
    }
    .line4 {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 2px;
      width: 13px;
      background-color: #191919;
    }
  }
  .games {
    box-sizing: border-box;
    padding-top: 24px;
    margin: 0 12px;
    .game {
      position: relative;
      .teams {
        position: relative;
        height: 80px;
        border-radius: 8px;
        padding: 4px 12px;
        box-sizing: border-box;
        background-color: #F9FAFC;
        .time {
          position: absolute;
          top: -18px;
          left: 0;
          font-size: 12px;
          font-weight: 500;
          color: #9E9E9E;
        }
        .team {
          height: 36px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          div {
            overflow: hidden;
          }
        }
      }
      .left {
        position: absolute;
        left: -65px;
        top: -45px;
        display: flex;
        flex-flow: row;
        align-items: center;
        .prev-games {
          width: 40px;
          height: 175px;
          position: relative;
          .base {
            width: 40px;
            height: 80px;
            background-color: #F9FAFC;
            box-sizing: border-box;
            padding: 12px 10px 12px 10px;
            border-radius: 6px;
            .logo {
              border-radius: 4px;
              overflow: hidden;
            }
          }
          .top {
            position: absolute;
            top: 0;
          }
          .bottom {
            position: absolute;
            bottom: 0;
          }
        }
      }
      .right {
        width: 65px;
        position: absolute;
        top: -90px;
        right: -65px;
        display: flex;
        flex-flow: row;
        align-items: center;
        .next {
          width: 40px;
          height: 80px;
          box-sizing: border-box;
          background-color: #F9FAFC;
          padding: 12px 10px 12px 10px;
          border-radius: 6px;
          .logo {
            border-radius: 4px;
            overflow: hidden;
          }
        }
      }
    }
    .w1 {
      margin-bottom: 50px;
      width: 80%;
    }
    .w2 {
      margin: 0 auto 110px;
      width: 60%;
    }
  }
}
</style>
